import React from 'react';
import styles from '../AddProduct.module.css';

function SEOSettings({
    metaTitle,
    setMetaTitle,
    metaDescription,
    setMetaDescription,
    slug,
    setSlug,
    generateSlug,
    focusKeywords,
    keywordInput,
    setKeywordInput,
    addKeyword,
    removeKeyword,
    brandName,
    setBrandName,
    availability,
    setAvailability,
    productCondition,
    setProductCondition,
    errorFields,
    setErrorFields,
    handleFieldChange,
}) {
    return (
        <div className={styles['AddProduct-card']}>
            <h2 className={styles['AddProduct-card-title']}>SEO Settings</h2>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Meta Title
                    <span className={styles['AddProduct-label-optional']}>
                        {' '}
                        (Optional)
                    </span>
                </label>
                <input
                    onChange={handleFieldChange(
                        'metaTitle',
                        setMetaTitle,
                        errorFields,
                        setErrorFields
                    )}
                    type="text"
                    className={styles.form__input_add}
                    placeholder="Custom title for search engines"
                    value={metaTitle}
                    maxLength="60"
                />
                <div className={styles['AddProduct-help-text']}>
                    {metaTitle.length}/60 characters • Recommended: 50-60
                    characters
                </div>
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Meta Description
                    <span className={styles['AddProduct-label-optional']}>
                        {' '}
                        (Optional)
                    </span>
                </label>
                <textarea
                    onChange={handleFieldChange(
                        'metaDescription',
                        setMetaDescription,
                        errorFields,
                        setErrorFields
                    )}
                    className={styles['AddProduct-textarea']}
                    placeholder="Description shown in search results"
                    value={metaDescription}
                    maxLength="160"
                    rows="3"
                />
                <div className={styles['AddProduct-help-text']}>
                    {metaDescription.length}/160 characters • Recommended:
                    150-160 characters
                </div>
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    URL Slug
                    <span className={styles['AddProduct-label-optional']}>
                        {' '}
                        (Auto-generated)
                    </span>
                </label>
                <input
                    onChange={(e) => setSlug(generateSlug(e.target.value))}
                    type="text"
                    className={styles.form__input_add}
                    placeholder="product-url-slug"
                    value={slug}
                />
                <div className={styles['AddProduct-help-text']}>
                    Auto-generated from product title. Lowercase letters and
                    hyphens only.
                </div>
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Focus Keywords
                    <span className={styles['AddProduct-label-optional']}>
                        {' '}
                        (Optional)
                    </span>
                </label>
                <div className={styles['AddProduct-keyword-input-group']}>
                    <input
                        type="text"
                        className={styles.form__input_add}
                        placeholder="Enter keyword and press Enter"
                        value={keywordInput}
                        onChange={(e) => setKeywordInput(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                addKeyword();
                            }
                        }}
                    />
                    <button
                        type="button"
                        className={styles['AddProduct-keyword-add-btn']}
                        onClick={addKeyword}
                    >
                        Add
                    </button>
                </div>
                {focusKeywords.length > 0 && (
                    <div className={styles['AddProduct-keywords-list']}>
                        {focusKeywords.map((keyword, index) => (
                            <span
                                key={index}
                                className={styles['AddProduct-keyword-tag']}
                            >
                                {keyword}
                                <button
                                    type="button"
                                    onClick={() => removeKeyword(keyword)}
                                    className={
                                        styles['AddProduct-keyword-remove']
                                    }
                                >
                                    ×
                                </button>
                            </span>
                        ))}
                    </div>
                )}
                <div className={styles['AddProduct-help-text']}>
                    Add 3-5 keywords that describe your product
                </div>
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Availability Status
                </label>
                <select
                    name="availability"
                    className={styles['AddProduct-category']}
                    value={availability}
                    onChange={handleFieldChange(
                        'availability',
                        setAvailability,
                        errorFields,
                        setErrorFields
                    )}
                >
                    <option value="in_stock">In Stock</option>
                    <option value="out_of_stock">Out of Stock</option>
                    <option value="preorder">Pre-order</option>
                    <option value="backorder">Backorder</option>
                </select>
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Product Condition
                </label>
                <select
                    name="productCondition"
                    className={styles['AddProduct-category']}
                    value={productCondition}
                    onChange={handleFieldChange(
                        'productCondition',
                        setProductCondition,
                        errorFields,
                        setErrorFields
                    )}
                >
                    <option value="new">New</option>
                    <option value="used">Used</option>
                    <option value="refurbished">Refurbished</option>
                </select>
            </div>
        </div>
    );
}

export default SEOSettings;
